import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ds-top-slot-headline-subheadline" }
const _hoisted_2 = ["innerHTML", "id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["innerHTML"]

import WebpImage from "../image/webp-image.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-top-subheadline',
  props: {
    headline: {},
    subheadline: {},
    imageSrc: {},
    imageAlt: {},
    displayHeadlineAsHtml: { type: Boolean },
    dialogLabelId: { default: "dialog-label" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.imageSrc)
      ? (_openBlock(), _createBlock(WebpImage, {
          key: 0,
          src: _ctx.imageSrc,
          alt: _ctx.imageAlt,
          "css-class": "ds-top-slot-headline-subheadline__image"
        }, null, 8, ["src", "alt"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_ctx.displayHeadlineAsHtml)
        ? (_openBlock(), _createElementBlock("h2", {
            key: 0,
            class: "ds-top-slot-headline-subheadline__headline",
            innerHTML: _ctx.headline,
            id: _ctx.dialogLabelId
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("h2", {
            key: 1,
            class: "ds-top-slot-headline-subheadline__headline",
            id: _ctx.dialogLabelId
          }, _toDisplayString(_ctx.headline), 9, _hoisted_3)),
      (_ctx.subheadline)
        ? (_openBlock(), _createElementBlock("p", {
            key: 2,
            class: "ds-top-slot-headline-subheadline__subheadline",
            innerHTML: _ctx.subheadline
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})